<i18n
  src="@/locales/components/views/packing_house/production/uniq_final_packing_list/show_container/tabs/container.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div v-if="container">
    <h1 class="page-title">
      <i class="fa-solid fa-truck-container"></i><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>
    <div class="flex flex-row justify-end">
      <tabs-download-buttons-packing-list
        :container_code="container?.container_code"
        :container_id="this.container_id"
      />
    </div>
    <div class="panel">
      <div class="panel-body" >
        <div class="divide-gray-200">
          <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container.package_groups") }}
              </dt>
              <dd class="content-data">
                {{ container.package_groups.length }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container.gross_weight") }}:
              </dt>
              <dd class="content-data">
                {{ container.gross_weight }} Kg
              </dd>
            </div>
            <div class="sm:col-span-2">
              <h3 class="px-3"></h3>
              <dt class="label-data">
                {{ $t("model.container.net_weight") }}:
              </dt>
              <dd class="content-data">
                {{ container.net_weight }} Kg
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container.exporter_process_crop_category") }}
              </dt>
              <dd class="content-data">
                {{
                  container.category_name
                }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container.exporter_process_crop_variety") }}
              </dt>
              <dd class="content-data">
                {{
                  container.variety_name
                }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container.exporter_process_brand") }}:
              </dt>
              <dd class="content-data">
                {{
                  container.brand_name
                }}
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
    <container-planning :container_planning="container.container_planning" />
  </div>
</template>

<script>
import TabsDownloadButtonsPackingList from "./DownloadButtonsPackingList.vue";
import ContainerPlanning from "@/components/views/packing_house/production/uniq_final_packing_list/show_container/ContainerPlanning.vue";

export default {
  name: "ContainerTab",
  components: { TabsDownloadButtonsPackingList, ContainerPlanning },
  props: {
    container: {
      type: Object,
      required: true
    },
    container_id: { required: true }
  }
};
</script>
